import PersonCircle from './PersonCircle';

export default PersonCircle;
